import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "enquiries--wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "block-wrapper"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row-value" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = {
  key: 1,
  class: "block-wrapper"
}
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.enquiries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.enquiries, (enquiry, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "block",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-title" }, "Lot:", -1)),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(enquiry.lotTitle ? enquiry.lotTitle : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Source:", -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(enquiry.source ? enquiry.source : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "Date:", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(enquiry.date ? $setup.formatDate(enquiry.date, "DD MMM YYYY") : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Message:", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(enquiry.text ? enquiry.text : "-"), 1)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "block" }, [
                _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("span", null, "This lead has not submitted any enquiry yet")
                ])
              ], -1)
            ]))]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12))
}